<div class="mei">
  <div class="mei__search">
    <mat-icon class="mei__search-icon" aria-hidden="true">search</mat-icon>
    <input
      class="mei__search-input"
      type="text"
      [value]="searchTerm()"
      (input)="onSearch($event)"
      [attr.aria-label]="'modules.embedInline.searchLabel' | translate"
      [placeholder]="'modules.embedInline.searchPlaceholder' | translate"
    />
  </div>

  @if (loading()) {
    <p class="mei__hint">{{ 'modules.embedInline.loading' | translate }}</p>
  } @else if (error()) {
    <p class="mei__hint mei__hint--error" role="alert">{{ 'modules.embedInline.error' | translate }}</p>
  } @else {
    <div class="mei__list" role="list" [attr.aria-label]="'modules.embedInline.listLabel' | translate">
      @for (candidate of candidates(); track candidate.id) {
        <button
          type="button"
          class="mei__item"
          [attr.aria-label]="'modules.embedInline.selectAria' | translate: { name: candidate.name }"
          (click)="select(candidate)"
        >
          <mat-icon class="mei__item-icon" aria-hidden="true">extension</mat-icon>
          <code class="mei__item-key">{{ candidate.key }}</code>
          <span class="mei__item-name">{{ candidate.name }}</span>
          <mat-icon class="mei__item-add" aria-hidden="true">add</mat-icon>
        </button>
      } @empty {
        <p class="mei__empty">{{ 'modules.embedInline.empty' | translate }}</p>
      }
    </div>
  }

  <button type="button" class="mei__cancel" (click)="close()">{{ 'modules.embedInline.cancel' | translate }}</button>
</div>
